import type { ChangeEvent, ReactNode } from "react";

import type { IKeywordsGroupEditorController } from "app/pages/keyword-analysis/useKeywordsGroupEditorController";
import type { IUserKeywordGroup } from "app/services/keyword-groups/keywordGroups.types";
import type { ITopic } from "pro-features/pages/module start page/src/keyword analysis/topics/types";

export type IAiTopic = {
    seed: string;
};
export type IAutocompleteKeyword = {
    name: string;
};
export type IAutocompleteKeywordGroup = IUserKeywordGroup & { SharedWithMe: boolean };

export interface IKeywordAutocompleteResults {
    hasQuery: boolean;
    keywordGroups: IAutocompleteKeywordGroup[];
    sharedKeywordGroups: IAutocompleteKeywordGroup[];
    keywords?: IAutocompleteKeyword[];
    topics?: ITopic[];
    aiTopics?: IAiTopic[];
}
export interface ISearchedKeyword {
    name: string;
    image?: string;
}

type KeywordOrGroupType = IUserKeywordGroup | ISearchedKeyword;
export type AvailableTabName = "keywords" | "keywordGroups" | "topics" | "aiTopics";

export const getName = (item: string | KeywordOrGroupType | IAiTopic) => {
    if (typeof item === "object") {
        if ("name" in item) {
            return item.name;
        } else if ("Name" in item) {
            return item.Name;
        } else if ("seed" in item) {
            return item.seed;
        } else {
            return "";
        }
    } else {
        return item;
    }
};

export type AutoCompleteOnClick = (
    selectedValue:
        | IAiTopic
        | ITopic
        | KeywordOrGroupType
        | KeywordOrGroupType[]
        | Partial<KeywordOrGroupType>
        | string
        | string[],
    e: ChangeEvent<HTMLInputElement>,
) => void;

export interface IAutocompleteKeywordGroupsDeleteContext {
    controller: IKeywordsGroupEditorController;
    onDeleted?: (deletedGroup: { Id: string }) => void;
}

export type IAutocompleteKeywordGroupsProps = {
    className?: string;
    children?: ReactNode;
    selectedValue?: string | KeywordOrGroupType;
    onValueChange?: (value: string | KeywordOrGroupType) => void;
    autocompleteProps: any;
    showGoToMonitorKeywordListButton?: boolean;
    handleSave?: (modifiedGroup: IUserKeywordGroup) => void;
    onClick: AutoCompleteOnClick;
    onAutoCreateKeywordGroupClick?: AutoCompleteOnClick;
    /**
     * Forces the autocomplete to show results according to selectedValue, even if no query is present.
     * this is used by the queryBar items, to enable immediate search in the autocomplete, upon clicking
     * an item.
     */
    forceResultsView?: boolean;

    /**
     * Forces focus on the selected result tab. if no value is provided, then the keywords tab will be opened by default
     */
    defaultSelectedTab?: AvailableTabName;

    onGroupShareModalOpened?: () => void;
    onGroupShareModalClosed?: () => void;
    onGroupDelete?: (deletedGroup: { Id: string }) => void;
    onClearSearch?: () => void;
    onGroupEditorModalOpened?: () => void;
    onGroupEditorModalClosed?: () => void;
    showKeywords?: boolean;
    overrideEnterFunc?: (event: FixmeType, index: number) => void;
    /**
     * *  in case item selected from the render Items clear the text field value
     */
    clearTextValueOmItemSelect?: boolean;
    refocusOnItemSelect?: boolean;
    showEditButton?: boolean;
    showShareButton?: boolean;
    includeComparisons?: boolean;
    showAutoCreateKeywordGroupButton?: boolean;
    keywordsToFilterFromAutocomplete?: string[];
    keywordsGroupsToFilterFromAutocomplete?: string[];
    truncateResultsOnBodyClick?: boolean;
    onBeforeDeleteKeywordGroup?: (
        group: IUserKeywordGroup | undefined,
        context: IAutocompleteKeywordGroupsDeleteContext,
    ) => void;
    controller?: IKeywordsGroupEditorController;
    tabTitles?: {
        keywordsTabTitle?: string;
        keywordGroupsTabTitle?: string;
        topicsTabTitle?: string;
        aiTopicsTabTitle?: string;
    };
};
